import {fsa, fsaError, fsaPayload} from './helpers'

export const APPLY_PROMO_CODE = 'apply promo code'
export const applyPromoCode = fsaPayload(APPLY_PROMO_CODE)

export const APPLY_PROMO_CODE_PENDING = 'apply promo code is pending'
export const applyPromoCodePending = fsa(APPLY_PROMO_CODE_PENDING)

export const APPLY_PROMO_CODE_SUCCESS = 'apply promo code was successful'
export const applyPromoCodeSuccess = fsaPayload(APPLY_PROMO_CODE_SUCCESS)

export const APPLY_PROMO_CODE_FAILURE = 'apply promo code was not successful'
export const applyPromoCodeFailure = fsaError(APPLY_PROMO_CODE_FAILURE)

export const UPDATE_PROMO_STATUS_MESSAGE = 'update promo status message'
export const updatePromoStatusMessage = fsaPayload(UPDATE_PROMO_STATUS_MESSAGE)

export const DISPLAY_OVERRIDE = 'display promo override confirmation ui'
export const displayOverride = fsa(DISPLAY_OVERRIDE)

export const HIDE_OVERRIDE = 'hide promo override confirmation ui'
export const hideOverride = fsa(HIDE_OVERRIDE)

export const SET_ERROR = 'set promo error status flag'
export const setError = fsaPayload(SET_ERROR)

export const RESET_PROMO = 'reset promo form'
export const resetPromo = fsaPayload(RESET_PROMO)
